import { SERVER_ROOT } from 'env';

const paddleRoot = `${SERVER_ROOT}/paddle`;

async function parseResponse(res) {
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json?.message || 'Request failed');
    err.code = json?.code;
    err.status = res.status;
    throw err;
  }
  return json;
}

export async function createPortalSession() {
  const res = await fetch(`${paddleRoot}/portal-session`, {
    method: 'POST',
    credentials: 'include',
  });
  return parseResponse(res);
}

export async function changePlan(plan) {
  const res = await fetch(`${paddleRoot}/change-plan`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ plan }),
  });
  return parseResponse(res);
}
